import DashboardTopSection from "./dashboard-top-section";
import CurrentVisasTable from "../../components/table/current-visas-table";
import CancelingTable from "../../components/table/canceling-table";
import VisaTypeChart from "./charts/visa-type-chart";
import CrewDashboard from "./crewDashbord";
import { useSelector } from "react-redux";
import AgentCurrentTable from "../../components/table/agent-current-visas-table";
import { NewCurrentVisaTable } from "../../components/table/NewCurrentVisaTable/new-current-visas-table ";
import Crew from "../crew";



const Dashboard = () => {
  const user = useSelector((state) => state.user.user)


  const isCrewAgent = user?.role_key?.toLowerCase() === "crewAgent"?.toLowerCase()

  if (isCrewAgent) ///CREW_AGENT DASHBOARD IS CREW PAGE
    return <Crew />


  return <div className={"my-container mb-20"}>
    {
      (user?.role_key === "crew" || !user?.role_key) ?
        <CrewDashboard />
        :
        <>
          <DashboardTopSection />
          <div className={"flex flex-col md:flex-row gap-5 mt-3"}>
            {/*<div className={"w-full md:w-2/5"}>*/}
            {/*  <VisaTypeChart/>*/}
            {/*</div>*/}
            {/* <div className={"w-full "}>
              <CancelingTable/>
            </div> */}
          </div>

          <NewCurrentVisaTable />
          {/* {
            user?.role_key === "agent" ? <AgentCurrentTable/> : <CurrentVisasTable/>
          }  */}

        </>
    }
  </div>
};

export default Dashboard;
